var exports = {
  "qd": "FloatingUnreadIndicators.module__layer___UEhEMF",
  "NI": "FloatingUnreadIndicators.module__slot___UEhEMF",
  "AH": "FloatingUnreadIndicators.module__slotTop___UEhEMF",
  "Y0": "FloatingUnreadIndicators.module__slotBottom___UEhEMF",
  "q3": "FloatingUnreadIndicators.module__indicator___UEhEMF",
  "lL": "FloatingUnreadIndicators.module__indicatorBrand___UEhEMF",
  "Gi": "FloatingUnreadIndicators.module__indicatorMention___UEhEMF",
};

module.exports = exports;
